/**
 * Folder API — binding to the shared createFolderApi(http) factory in
 * packages/common, bound to web's apiClient singleton.
 */

import { apiClient } from "@/lib/api/client";
import { createFolderApi } from "@speakai/common/src/folder/api";

export type {
  ViewColumn,
  FolderView,
  Folder,
  FolderListResponse,
  FolderListQueryParams,
  FolderSource,
  ApiResult,
  CreateFolderData,
  CreateFolderResult,
  UpdateFolderData,
  UpdateFolderResult,
  CloneFolderData,
  CloneFolderResult,
  ReanalyzeFolderParams,
  CreateFolderViewData,
} from "@speakai/common/src/folder/types";

export const {
  getFolderList,
  getFolderDetail,
  getFolderViews,
  createFolder,
  updateFolder,
  deleteFolder,
  cloneFolder,
  reanalyzeFolder,
  createFolderView,
  updateFolderView,
  deleteFolderView,
  updateShowOrder,
  setupFolderAutomation,
} = createFolderApi(apiClient);
